<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    return {
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 600,
          width: 1300,
          type: "bar",
          fontFamily: "Helvetica, Arial, sans-serif",
          toolbar: {
            show: false,
          }
        },
        labels_data: [],
        colors: [],
        plotOptions: {
          bar: {
            distributed: true,
            dataLabels: {
              position: "bottom"
            }
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: "Helvetica, Arial, sans-serif",
          }
        },
        legend: {
          show: true,
          position: "right",
          width: 500,
          fontFamily: "Helvetica, Arial, sans-serif",
          formatter: function (value, { seriesIndex, w }) {
            return w.config.labels_data[seriesIndex];
          },
          fontSize: "12px",
          fontWeight: "500",
          color: "black",
          itemMargin: {
            vertical: 0,
          },
          offsetX: -30,
        },
        title: {
          text: this.language === 'tr' ? 'SKA Alt Hedef Hizalama (SKA Hizalama Anket Sonucu)' : "SDG Sub Target Alignment (SDG Alignment Survey Result)",
          align: "center",
          style: {
            fontSize: "20px",
            heigth: "100px",
            fontFamily: 'Muli, Arial, sans-serif',
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
            },
          },
        },
      },
    };
  },

  mounted() {
    this.getNames();
  },

  props: {
    selectedSurveyID: null,
    language: {
      type: String,
      default: localStorage.getItem('lang') || 'en',
    }
  },

  methods: {
    handleColorById(id) {
      let color = "";
      if (id === 1) {
        color = "#e5233d"
      }
      else if (id === 2) {
        color = "#dda73a"
      }
      else if (id === 3) {
        color = "#4ca146"
      }
      else if (id === 4) {
        color = "#c5192d"
      }
      else if (id === 5) {
        color = "#ef402c"
      }
      else if (id === 6) {
        color = "#27bfe6"
      }
      else if (id === 7) {
        color = "#fbc412"
      }
      else if (id === 8) {
        color = "#a31c44"
      }
      else if (id === 9) {
        color = "#f26a2d"
      }
      else if (id === 10) {
        color = "#e01483"
      }
      else if (id === 11) {
        color = "#f89d2a"
      }
      else if (id === 12) {
        color = "#bf8d2c"
      }
      else if (id === 13) {
        color = "#407f46"
      }
      else if (id === 14) {
        color = "#1f97d4"
      }
      else if (id === 15) {
        color = "#59ba48"
      }
      else if (id === 16) {
        color = "#126a9f"
      }
      else if (id === 17) {
        color = "#13496b"
      }
      else {
        return null
      }
      return color
    },
    getLabelName(element) {
      const stopChar = " ";
      const stopIndex = element.indexOf(stopChar);
      if (stopIndex != -1) {
        const labelName = element.slice(0, stopIndex);
        return labelName
      }
    },
    sortDataHigh2Low(response) {
      const allData = [];

      response.data.series.forEach((item) => {
        item.data.forEach((subGoalData) => {
          const innerData = {
            "x": Number(subGoalData.x),
            "y": Number(subGoalData.y),
            "element": subGoalData.element,
            "globalGoalID": subGoalData.globalGoalID,
            "subGoalID": subGoalData.subGoalID,
            "name": item.name
          };

          allData.push(innerData);
        });
      });
      allData.sort((a, b) => b.y - a.y)
      return allData;
    },

    ...mapActions("results", ["su1SubColumn"]),
    getNames() {
      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
        language: this.language,
      };

      this.su1SubColumn(params)
        .then(response => {
          const allData = this.sortDataHigh2Low(response);
          // "SDG" / "SKA" in the chart's own language, which can differ from the UI language when a report graph is captured
          const sdgPrefix = this.$t('su1Results.resultsPage.graph.sdgPrefix', this.language);
          for (let idx = 0; idx < 20; idx++) {
            this.series[0].data.push(allData[idx].y);
            this.chartOptions.labels_data.push(sdgPrefix + " " + allData[idx].element);
            this.chartOptions.xaxis.categories.push(sdgPrefix + " " + this.getLabelName(allData[idx].element));
            this.chartOptions.colors.push(this.handleColorById(allData[idx].globalGoalID));
            this.chartOptions.xaxis.labels.style.colors.push(this.handleColorById(allData[idx].globalGoalID));
          }
        })
    },
  },
};
</script>

<template>
  <apex-chart v-if="series[0].data.length > 0" type="bar" width="100%" :options="chartOptions"
    :series="series"></apex-chart>
</template>

<style scoped>

.apexcharts-legend-series {
  padding-right: .5px;
  text-align: left;
}

.apexcharts-title-text {
  margin-bottom: 5px !important;
}


</style>